import { ReactNode, useEffect, useState } from 'react';
import ThemeContext from '@/shared/context/ThemeContext';
import { toggleDarkTheme } from '@/shared/helpers/browserHelpers';
import { getStorageItem, setStorageItem } from '@/shared/helpers/storage';
import { THEME_COOKIE_NAME } from '@/shared/utils/constants';

function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<'dark' | 'light'>('light');

  useEffect(() => {
    const getInitialTheme = async () => {
      const storedTheme = await getStorageItem(THEME_COOKIE_NAME);

      if (storedTheme === 'dark' || (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        toggleDarkTheme(true);
        setTheme('dark');
      } else {
        setTheme('light');
      }
    };

    void getInitialTheme();
  }, []);

  const handleThemeToggle = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';

    toggleDarkTheme(nextTheme === 'dark');

    setStorageItem(THEME_COOKIE_NAME, nextTheme);
    setTheme(nextTheme);
  };

  return (
    <ThemeContext.Provider
      value={{
        theme: theme,
        isDarkMode: theme === 'dark',
        toggleTheme: handleThemeToggle
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
